define('views/components/go_order/license_list',['require','views/base/list_view','views/components/go_order/license','text!templates/components/go_order/license_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/go_order/license');

    var temp = require("text!templates/components/go_order/license_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});
